module.exports = __webpack_public_path__ + "static/media/spice_featured.374bd237.jpg";